// directives/convert.js

export default {
  bind(el, binding) {
    updateValue(el, binding);
  },
  
  update(el, binding) {
    updateValue(el, binding);
  },
  
  unbind(el) {
    // 清理
  }
};

function updateValue(el, binding) {
  const value = binding.value;
  const digits = binding.modifiers?.digits || binding.arg || '1.2-2';
  const animation = binding.modifiers?.animation || false;
  
  if (value !== undefined && value !== null && value !== '') {
    const formatted = formatCurrency(value, digits);
    
    if (el.textContent !== formatted) {
      el.textContent = formatted;
      
      if (animation) {
        el.style.transition = 'all 0.3s ease';
        el.style.transform = 'scale(1.05)';
        setTimeout(() => {
          el.style.transform = 'scale(1)';
        }, 300);
      }
    }
  }
}

function formatCurrency(value, digits = '1.2-2') {
  const num = typeof value === 'number' ? value : parseFloat(value);
  
  if (isNaN(num) || num === 0) {
    return '0';
  }
  
  // 解析 digits 格式：最小整数.最小小数-最大小数
  const parts = digits.split('.');
  const minInt = parseInt(parts[0]) || 1;
  
  let minFraction = 0;
  let maxFraction = 0;
  
  if (parts.length > 1) {
    const fractionParts = parts[1].split('-');
    minFraction = parseInt(fractionParts[0]) || 0;
    maxFraction = fractionParts.length > 1 ? parseInt(fractionParts[1]) : minFraction;
  }
  
  const formatted = num.toLocaleString('en-US', {
    minimumIntegerDigits: minInt,
    minimumFractionDigits: minFraction,
    maximumFractionDigits: maxFraction
  });
  
  return formatted;
}